import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSuccessPage } from "@/pages/subscription-setup";

export const Route = createFileRoute(
  "/_authed/_noSidebar/$companySlug/subscribe/success",
)({
  component: SubscriptionSuccessPage,
});
